module.exports = __webpack_public_path__ + "static/media/icon_instrument_accordion.81f5bcc8.svg";